import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import * as moment from 'moment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { configData } from 'src/environments/configData';

@Injectable({
  providedIn: 'root',
})
export class HttpCall {
  temp_gif = localStorage.getItem(localStorageConstants.INVOICE_GIF);
  gif = configData.DEFAULT_LOADER_GIF;

  constructor(private http: HttpClient) { }

  getLoader(): string {
    return this.temp_gif != null &&
      this.temp_gif != undefined &&
      this.temp_gif != ''
      ? this.temp_gif
      : this.gif;
  }

  public httpGetCall(apiRoute: string): Observable<any> {
    const portalType = sessionStorage.getItem(localStorageConstants.USERTYPE);
    let token = '';
    if (portalType == 'smartaccupay-portal') {
      token = localStorage.getItem(localStorageConstants.INVOICE_TOKEN) || '{}';
    } else {
      token = localStorage.getItem(localStorageConstants.SUPERADMIN_TOKEN) || '{}';
    }
    const language = 'en';
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', token);
    //headers = headers.set('local_offset', '' + moment().utcOffset() * 60);
    headers = headers.set('language', language);

    return this.http.get(apiRoute, { headers: headers }).pipe(
      map((res) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  public httpPostCall(apiRoute: string, userData: any): Observable<any> {
    const portalType = sessionStorage.getItem(localStorageConstants.USERTYPE);
    let token = '';
    if (portalType == 'smartaccupay-portal') {
      token = localStorage.getItem(localStorageConstants.INVOICE_TOKEN) || '{}';
    } else {
      token = localStorage.getItem(localStorageConstants.SUPERADMIN_TOKEN) || '{}';
    }
    const language = 'en';
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', token);
    //headers = headers.set('local_offset', '' + moment().utcOffset() * 60);
    headers = headers.set('language', language);

    return this.http.post(apiRoute, userData, { headers: headers }).pipe(
      map((res) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  handleError(error: any) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error);
  }

  public httpPostCallWithoutToken(apiRoute: string, userData: any): Observable<any> {
    const portal_language = 'en';
    let headers: any = new HttpHeaders();
    headers = headers.set('language', portal_language);
    return this.http.post(apiRoute, userData, { headers: headers }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }
  public httpPostCallWithoutTokenWidthParams(apiRoute: string, userData: any, params?: any): Observable<any> {
    const portal_language = 'en';
    let headers: any = new HttpHeaders();
    headers = headers.set('language', portal_language);

    // Append query parameters to the URL if provided
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      apiRoute += `?${queryParams}`;
    }

    return this.http.post(apiRoute, userData, { headers: headers }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }
}
